import {
  toResponseError,
  type DashboardData,
  type DashboardDataWithEditable,
  type DashboardListInput,
  type DashboardUpdateInput,
  type DashboardUpdateSuccess,
} from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { type UpdateHookResponse, mutationUpdate } from '../hooks'
import { useDashboardCache } from './cache'

export function useUpdateDashboard(
  input?: DashboardListInput
): UpdateHookResponse<DashboardData, DashboardDataWithEditable> {
  const cache = useDashboardCache(input)
  const mutation = useTantalimMutation<DashboardUpdateInput, DashboardUpdateSuccess>({
    url: '/report/dashboard/update',
  })

  async function update(input: DashboardData): Promise<DashboardDataWithEditable> {
    try {
      const { dashboard } = await mutation.mutateAsync({ dashboard: input })
      cache.setItem(dashboard)
      return dashboard
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
